import Container from '../../atoms/container/pilotContainer';
import Mask from './pilotMask';
import Vod from './pilotVod';
import Zapper from './pilotZapper';
import { PilotProps as Props } from '../../../../shared/types/props/pilot';
import { adsSelector } from '@shared/store/slices/ads.slice';
import { useAppSelector } from '@shared/store/hooks';

function Pilot({ channel, vod }: Props) {
  const { playAd, pauseAd } = useAppSelector(adsSelector);
  if (playAd?.active || pauseAd?.active) {
    return null;
  }
  return (
    <Container>
      <Mask />
      {vod ? <Vod asset={vod} /> : null}
      {channel ? <Zapper asset={channel} /> : null}
    </Container>
  );
}

export default Pilot;
